/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const mobilemenu = () => {
  document
    .querySelector('.js-mobile-menu-trigger')
    .addEventListener('click', e => {
      document.querySelector('.js-mobile-menu').classList.toggle('is-active');
      document
        .querySelector('.js-mobile-menu-trigger')
        .classList.toggle('is-active');
    });
};

export default mobilemenu;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/factory-logistic-chisel/src/scripts/modules/mobilemenu.js